<template>
  <v-card>
    <div class="pa-2 px-4">
      <div class="pb-2">News</div>
      <v-divider></v-divider>
      <div v-if="loading" class="my-3 text-center">
        <v-progress-circular indeterminate />
      </div>
      <div v-else>
        <News v-for="item of items" :key="item.id" :item="item" />
      </div>
    </div>
    <v-btn small v-if="!loading"  block to="/news">View All</v-btn>
  </v-card>
</template>

<script>
import News from "../News.vue";
export default {
  components: { News },
  name: "news",
  props:["loading","items"]
};
</script>

<style>
</style>